import { createFileRoute } from '@tanstack/react-router'
import { ServiceFollowUpsPage } from '../../../features/service/follow-ups-page'
import { serviceFollowUpsSearchSchema } from '../../../features/service/search'

export const Route = createFileRoute('/_app/service/follow-ups')({
  staticData: { crumb: 'serviceFollowUps' },
  validateSearch: serviceFollowUpsSearchSchema,
  component: ServiceFollowUpsPage,
})
